import { cancel, delaySound } from "common/promises";
import * as R from "ramda";
export function playTicketPrintSound(sound) {
    const retCanceler = new TicketPrintSoundCanceler(sound);
    const tickerSoundLoop = cancel.root(async (canceler) => {
        const playId = sound.play("chatbotTicketEffect1");
        if (playId != null) {
            retCanceler.addPlaying(playId);
            sound.sheet.once("end", () => {
                retCanceler.removePlaying(playId);
            }, playId);
        }
        while (true) {
            await delaySound(2140);
            canceler.check();
            const playId = sound.play("chatbotTicketEffect1");
            if (playId != null) {
                retCanceler.addPlaying(playId);
                sound.sheet.once("end", () => {
                    retCanceler.removePlaying(playId);
                }, playId);
            }
        }
    });
    retCanceler.canceler = tickerSoundLoop.canceler;
    retCanceler.promise = tickerSoundLoop.promise;
    return retCanceler;
}
export class TicketPrintSoundCanceler {
    constructor(sound) {
        this.playing = [];
        this.sound = sound;
    }
    cancel() {
        this.canceler.cancel();
        for (const playingId of this.playing) {
            this.sound.stop(playingId);
        }
        this.playing = [];
    }
    addPlaying(id) {
        this.playing.push(id);
    }
    removePlaying(toRemove) {
        this.playing = R.reject((id) => id === toRemove, this.playing);
    }
}
//# sourceMappingURL=ticketPrintSound.js.map